import React from 'react';
import Swipeable from './behaviours/swipeable';
//import Modal from '../modal/modal.jsx';

export default class CruiseDeals extends React.Component {
     constructor (props) {
        super(props);

         this.state = {
             items: this.props,
             index: 1,
             mouseDown: false,
             scrollX: 0,
             prevScrollX: 0,
         };

         this.setIndex = this.setIndex.bind(this);
         this.increaseIndex = this.increaseIndex.bind(this);
         this.decreaseIndex = this.decreaseIndex.bind(this);
         this.calculatePaginationScroll = this.calculatePaginationScroll.bind(this);
         this.onPaginationMouseDown = this.onPaginationMouseDown.bind(this);
         this.onPaginationMouseMove = this.onPaginationMouseMove.bind(this);
         this.onPaginationMouseUp = this.onPaginationMouseUp.bind(this);
         this.onCloseDestinationModal = this.onCloseDestinationModal.bind(this);
         this.openDescription = this.openDescription.bind(this);
     }

    componentDidMount() {

    }

    componentWillUnmount( ) {
        clearInterval(this.interval);
    }


    setIndex(startIndex){
        clearInterval(this.animationInterval);
        let newIndex = this.state.index;

        this.animationInterval = setInterval(() => {
            if(startIndex > this.state.index) newIndex = this.state.index + 1;
            if(startIndex < this.state.index) newIndex = this.state.index - 1;

            this.setState({
                index: newIndex,
                scrollX: this.calculatePaginationScroll(newIndex),
                prevScrollX: this.state.scrollX
            });

            if(this.state.index === startIndex) clearInterval(this.animationInterval);
        }, 100);
    }

    decreaseIndex(){
        clearInterval(this.animationInterval);
        let currentIndex = this.state.index;
        let newIndex = currentIndex - 1;

        if(currentIndex - 1 >= 1) {
            this.setState({
                index: newIndex,
                scrollX: this.calculatePaginationScroll(newIndex)
            });
        }
    }

    increaseIndex(){

        const data = Object.values(this.state.items);

        clearInterval(this.animationInterval);
        let currentIndex = this.state.index;
        let newIndex = currentIndex + 1;

        if ( data.length >= currentIndex + 1 ) {
            this.setState({
                index: newIndex,
                scrollX: this.calculatePaginationScroll(newIndex)
            });
        }
    }

    calculatePaginationScroll(newIndex){
        let itemWidth = 150;
        let containerWidth = itemWidth * 7;
        const data = Object.values(this.state.items);
        let scrollerWidth = itemWidth * (data.length - 1);

        let newScrollX = itemWidth * (newIndex - 3);
        let scrollXmt = 0;
        let scrollXlt = scrollerWidth - containerWidth;

        if( newScrollX >= scrollXmt && newScrollX <= scrollXlt) return newScrollX;
        return this.state.scrollX;
    }

    onPaginationMouseDown(e){
        this.setState({mouseDown: true, pageX: e.pageX, prevScrollX: this.state.scrollX})
    }

    onPaginationMouseMove(e){
        if(this.state.mouseDown){
            let newScrollX = this.state.prevScrollX + (this.state.pageX - e.pageX);
            this.setState({scrollX: newScrollX > 0 ? newScrollX : 0 });
        }
    }

    onPaginationMouseUp(e){
        this.setState({mouseDown: false});
    }

    onCloseDestinationModal(){
        //if(this.abortController) this.abortController.abort();


        this.setState({
            showModal:false,
            modalContent: this.defaultModalContent()
        });
    }

    loadDestination(url){
        let success = (html) => {
            let newContent = (<div className="text-left" dangerouslySetInnerHTML={{__html: html}} />);
            this.setState({modalContent: newContent});
        };

        let failure = (response) => {
            this.setState({showModal: false, modalContent: response});
        };

        this.setState({ showModal: true}, () => {
            //set new abort controller for request
            //this.abortController = new AbortController();
            // this.signal = this.abortController.signal;
            //this.api.setAbortSignal(this.signal).getPartial(url, success, failure, true, this.signal)
            this.APIManager.getPartial(url, success, failure, true, this.signal)
        })
    }

    openDescription(key, title, description){
        let content = ([
            <h3 key={key+'model_desc_title'}>{title}</h3>,
            <span key={key+'model_desc_desc'} dangerouslySetInnerHTML={{__html:description}} />
        ]);

        this.setState({showModal: true, modalContent: content});
    }

    renderSingleItem(key, item) {
         return (
             <div className="itinerary-driver--cruise-deals" key={key}>
                 <div className="itinerary-driver--cruise-deals--content-container">
                     <h4 key={item.title}>{item.title}</h4>
                     <p>{item.summaryText}</p>
                     {/*<div className="tag gold">tag info</div>*/}
                     <a className="button">Find out more</a>
                 </div>

                 <div className="itinerary-driver--image--cruise-deals" style={{backgroundImage: `url('${item.image}')`}}>
                     <div className="itinerary-driver--day--cruise-deals">
                         <img src={item.cruiseLineLogo}/>
                     </div>
                 </div>

             </div>
         )
     }

    renderItems() {
        let items = [];
        const data = Object.values(this.state.items);
        let count = data.length;
        let index = this.state.index;
        for (let i= 1; i <= count; i++) {
            let cssClass = '';
            if(index - 1 === i) cssClass = 'before-active';
            if(index === i) cssClass = 'active';

            items.push((
                <div key={'timeline-item_' + i} className={'timeline--item--cruise-deals timeline--item ' + cssClass}  onClick={() => this.setIndex(i)}>
                    { this.renderSingleItem(i, data[i-1]) }
                </div>
            ));
        }

        return items;
     }

    render () {
        const handlers = {
            onSwipedLeft: this.increaseIndex,
            onSwipedRight: this.decreaseIndex,
            preventDefaultTouchmoveEvent: true,
            trackTouch: true
        };

         return(
             <div className="timeline">
                 <Swipeable className="timeline--items-container--cruise-deals" {...handlers}>
                     {this.renderItems()}
                 </Swipeable>
                 <div className="timeline--controls">
                     <div className="timeline--control-prev prev--cruise-deals" onClick={this.decreaseIndex} />
                     {/*<div className="timeline--control-page"><div className="timeline--control-page-diamond"></div>Day { this.props.items[this.state.index - 1].day } </div>*/}
                     <div className="timeline--control-next next--cruise-deals" onClick={this.increaseIndex} />
                 </div>
             </div>
         )
    }

}